// Copyright (c) 2020 Deere & Company

import t from 'tcomb';

const LaborRateRequestCount = t.struct({
    acceptedCount: t.Number,
    newCount: t.Number,
    rejectedCount: t.Number,
    returnedCount: t.Number
}, {
    name: 'LaborRateRequestCount',
    strict: true
});

export const getDefaultState = () => new LaborRateRequestCount({
    acceptedCount: 0,
    newCount: 0,
    rejectedCount: 0,
    returnedCount: 0
});

export default LaborRateRequestCount;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/labor-rate-request-count.js